export enum TextAlignment {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right',
};
